import { range } from 'lodash'
import * as moment from 'moment'
import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../core/i18n'

interface ISelectValue {
  value: string
  label: string
}
const YEAR_MONTH_FORMAT = 'YYYY-MM'
const getValueData: (m: moment.Moment) => ISelectValue = m => {
  const labelFormat = I18n.locale === 'ja' ? 'YYYY年 MM月' : 'MMMM YYYY'

  return {
    label: m.format(labelFormat),
    value: m.format(YEAR_MONTH_FORMAT),
  }
}

function getSelectableYearMonthList(): ISelectValue[] {
  const list: ISelectValue[] = []
  const thisYear = moment().year()
  const monthRange = range(12)

  monthRange.forEach((month: number) => {
    list.push(getValueData(moment([thisYear - 1, month, 1])))
  })
  monthRange.forEach((month: number) => {
    list.push(getValueData(moment([thisYear, month, 1])))
  })

  return list
}

interface IProps {
  changeYearMonth: (event: React.FormEvent<HTMLSelectElement | HTMLButtonElement>) => void
  yearMonth: moment.Moment
}

const SimpleYearMonthSelect: React.FC<IProps> = props => {
  const { changeYearMonth, yearMonth } = props
  const list = getSelectableYearMonthList()
  return (
    <Select>
      <select onChange={changeYearMonth} value={yearMonth.format(YEAR_MONTH_FORMAT)}>
        {list.map(selectableYearMonth => (
          <option key={selectableYearMonth.value} value={selectableYearMonth.value}>
            {selectableYearMonth.label}
          </option>
        ))}
      </select>
      <span />
    </Select>
  )
}

const Select = styled.div`
  cursor: pointer;
  line-height: 0;
  &:hover {
    opacity: 0.75;
  }

  > select {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    border-radius: 0;
    border: 0;
    margin: 0;
    padding: 0;
    background: none transparent;
    vertical-align: middle;
    font-size: inherit;
    color: inherit;
    box-sizing: content-box;
    outline: none;
    cursor: pointer;
  }

  > span {
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid #4f5959;
  }
`
export default SimpleYearMonthSelect
